// Pure helpers for the learning MFE's course progress line and home banner.

// Share of the course's units the learner has completed, 0-100, from the
// progress API's completion_summary.
export function completionPct(summary) {
  if (!summary) { return 0; }
  const done = summary.complete_count || 0;
  const total = done + (summary.incomplete_count || 0) + (summary.locked_count || 0);
  return total ? Math.round((done / total) * 100) : 0;
}

// The course id in a learning MFE path (/learning/course/<id>/...), or null.
export function courseIdOf(pathname) {
  const m = /\/course\/([^/]+)/.exec(pathname || '');
  if (!m) { return null; }
  const id = decodeURIComponent(m[1]);
  return id.startsWith('course-v1:') ? id : null;
}

// "CSIR102" from course-v1:ThervuMitra+CSIR102+2026.
export function courseCodeOf(courseId) {
  const m = /^course-v1:[^+]+\+([^+]+)\+/.exec(courseId || '');
  return m ? m[1] : '';
}
